module.exports = __webpack_public_path__ + "img/16_115.7fdaa046.png";